var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{staticClass:"mb-5",attrs:{"title":"Biblioteca Digitale","icon":"it-bookmark","back-link":true}},[_c('p',{staticClass:"text-left mb-5"},[_vm._v(" Nella Biblioteca Digitale puoi consultare e/o scaricare la documentazione dell'Accordo Quadro ")]),_c('document-columns',{class:'pb-4'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }